// @flow
import menuItems from '@lumera_configs/side_menus/jewelry_education_menu.json';

import SideMenu from './SideMenu';

const JewelryEducationMenu = () => <SideMenu items={menuItems} />;

export default JewelryEducationMenu;
